import { Check } from 'lucide-react'
import { motion } from 'framer-motion'
import Button from '../ui/Button'

const BenefitsSection = () => {
  const benefits = [
    '5 tipos diferentes de registro de ponto',
    'Integração com sistemas de folha de pagamento',
    'Sistema antifraude e dentro da legislação',
    '100% de acordo com a portaria 671 e LGPD',
    'Interface intuitiva e fácil de usar',
    'Suporte técnico especializado',
    'Aplicativo mobile para Android e iOS',
    'Gestão de banco de horas automatizada'
  ]

  const scrollToContact = () => {
    document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section id="beneficios" className="py-20 bg-white dark:bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block px-4 py-2 rounded-full bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 text-sm font-semibold mb-4">
              Benefícios
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-6">
              Por que escolher o{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-800">
                Flow Clock?
              </span>
            </h2>
            <p className="text-xl text-gray-600 dark:text-gray-300 mb-8">
              Nossa plataforma oferece tudo que você precisa para uma gestão de ponto 
              eficiente, segura e em conformidade com a legislação brasileira.
            </p>

            <ul className="space-y-4 mb-8">
              {benefits.map((benefit, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                  className="flex items-start gap-3"
                >
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center mt-0.5">
                    <Check className="w-4 h-4 text-primary-600" />
                  </div>
                  <span className="text-lg text-gray-700 dark:text-gray-300">{benefit}</span>
                </motion.li>
              ))}
            </ul>

            <Button size="lg" onClick={scrollToContact}>
              Solicitar Demonstração Gratuita
            </Button>
          </motion.div>

          {/* Right - Visual */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative bg-gradient-to-br from-primary-500 to-accent-600 rounded-2xl p-12 shadow-2xl">
              {/* Badge */}
              <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 3, repeat: Infinity }}
                className="absolute -top-6 -right-6 bg-white dark:bg-gray-900 rounded-xl shadow-lg p-4 border border-gray-200 dark:border-gray-800"
              >
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-green-100 dark:bg-green-900/30 rounded-lg flex items-center justify-center">
                    <Check className="w-7 h-7 text-green-600" />
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 dark:text-gray-400 font-medium">Empresas Confiam</p>
                    <p className="text-2xl font-bold text-gray-900 dark:text-white">+1.000</p>
                  </div>
                </div>
              </motion.div>

              {/* Stats */}
              <div className="absolute -bottom-6 -left-6 flex gap-4">
                <motion.div
                  animate={{ y: [0, 10, 0] }}
                  transition={{ duration: 3, repeat: Infinity, delay: 0.5 }}
                  className="bg-white dark:bg-gray-900 rounded-xl shadow-lg p-4 border border-gray-200 dark:border-gray-800"
                >
                  <p className="text-3xl font-bold text-primary-600">98%</p>
                  <p className="text-xs text-gray-600 dark:text-gray-400">Satisfação</p>
                </motion.div>
                <motion.div
                  animate={{ y: [0, 10, 0] }}
                  transition={{ duration: 3, repeat: Infinity, delay: 0.7 }}
                  className="bg-white dark:bg-gray-900 rounded-xl shadow-lg p-4 border border-gray-200 dark:border-gray-800"
                >
                  <p className="text-3xl font-bold text-primary-600">24/7</p>
                  <p className="text-xs text-gray-600 dark:text-gray-400">Suporte</p>
                </motion.div>
              </div>

              {/* Placeholder Content */}
              <div className="space-y-4 text-white">
                <div className="h-8 bg-white/20 rounded-lg w-3/4"></div>
                <div className="h-32 bg-white/10 rounded-lg"></div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="h-24 bg-white/10 rounded-lg"></div>
                  <div className="h-24 bg-white/10 rounded-lg"></div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default BenefitsSection
